import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function Consulting() {
  return (
    <div className="section">
      <h1 className="fw-bold mb-3">Consulting</h1>
      <p className="fs-5 mb-2">
        Getting cloud strategy right from the start costs far less than correcting it later.
        Whether you're migrating to the cloud, rethinking your SaaS architecture, or managing
        runaway infrastructure costs, M3 Computing brings hands-on depth across every layer —
        and the communication skills to make sure your team understands not just what we
        built, but why.
      </p>
      <p className="fs-5 mb-5">
        We don't hand over slide decks and walk away. Every consulting engagement includes
        knowledge transfer, so your team can own the direction we set together.
      </p>

      <hr className="m3-divider mb-5" />

      <Row className="g-5">
        <Col md={6}>
          <h2 className="h4 fw-bold mb-2">Cloud Architecture &amp; Modernization</h2>
          <p>
            Designing cloud-native architectures and migration roadmaps that align with your
            technical constraints and business goals. We've led architecture work across AWS,
            GCP, and Azure, and designed for multi-cloud and hybrid environments where a
            single-provider strategy isn't the right answer.
          </p>
          <p>
            We work with your existing team — reviewing what you have, identifying the gaps,
            and building a prioritized roadmap that makes progress without breaking what's
            working.
          </p>
        </Col>

        <Col md={6}>
          <h2 className="h4 fw-bold mb-2">SaaS Strategy &amp; Platform Roadmapping</h2>
          <p>
            SaaS architecture decisions compound quickly. The choices you make about
            multi-tenancy, data isolation, and platform boundaries in the early stages
            determine what's easy or painful at scale.
          </p>
          <p>
            We help you design for growth from the start — so when you go from ten customers
            to a thousand, you're adding capacity, not rewriting core systems. For companies
            already at scale, we identify where the architecture is limiting growth and
            build a path forward.
          </p>
        </Col>

        <Col md={6}>
          <h2 className="h4 fw-bold mb-2">Cloud Cost Optimization</h2>
          <p>
            Cloud spend is easy to let run unchecked, especially in fast-moving engineering
            organizations. We audit your infrastructure, identify waste, and design governance
            models that keep costs aligned with actual usage — without slowing your teams down.
          </p>
          <p>
            We've driven significant cost reductions in enterprise cloud environments by
            combining architectural changes with engineering discipline: right-sizing,
            reservation strategies, and organizational accountability structures that stick.
          </p>
        </Col>

        <Col md={6}>
          <h2 className="h4 fw-bold mb-2">Multi-Cloud Design &amp; Governance</h2>
          <p>
            Avoiding vendor lock-in is a legitimate goal, but multi-cloud adds operational
            complexity that has to be managed. We design multi-cloud strategies that give you
            flexibility where it matters — and consolidation where it doesn't.
          </p>
          <p>
            We've designed and operated systems across AWS, GCP, and Azure simultaneously,
            including migration strategies that shift workloads between providers without
            service interruption. We help you get the benefits of multi-cloud without paying
            for the complexity you don't need.
          </p>
        </Col>
      </Row>
    </div>
  );
}
